import React, { useEffect, useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router';
import { get } from 'lodash';
import { RootState } from 'modules';
import { useRecoilState } from 'recoil';
import scrollIntoView from 'scroll-into-view';
import ResettableOrderingButton from 'components/base/ResettableOrderingButton';
import ResettableSearchInput from 'components/base/ResettableSearchInput';
import SearchInput from 'components/base/SearchInput';
import { StyledGuideEnroll } from 'components/community/acceptance/FinalAcceptanceList';
import InterviewDetail from 'components/community/parts/interviewDetail/interviewDetail';
import CompleteModal from 'components/community/parts/modal/CompleteModal';
import LoginRequiredModal from 'components/community/parts/modal/LoginRequiredModal';
import ShareLinkMenu from 'components/community/parts/ShareLinkMenu';
import QuizListSearchInput from 'components/learning/quiz/components/parts/QuizListSearchInput';
import { makeQueryString } from 'libs/api/apiClient';
import { getInterviewReviewList, communityHitConut } from 'libs/api/community';
import { usePagination, useDataApi } from 'libs/hooks';
import { makeLastNYearsList } from 'libs/utils';
import { getUrlQuery } from 'libs/utils';
import { TInterviewReview } from 'modules/community';
import { completeModalVisibleState } from 'modules/community/recoilState';
import { TListResponse, TPagination } from 'modules/types';
import { TModalState } from 'modules/types';
import { CWindowWidth } from 'constants/base.const';
import { CEmploymentType } from 'constants/community.const';
import { EEmploymentType } from 'enums/community.enum';
import { ERoute } from 'enums/route.enum';
import { List, Button, Switch, Select, Form, Typography } from 'antd';
import { SearchOutlined, CloseOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { device, PrimaryColor, Colors } from 'GlobalStyles';
import refresh from 'assets/icons/refresh.svg';
import topBanner from 'assets/images/banners/8.webp';
import enrollTicket from 'assets/images/pages/community/enrollTicket.webp';
import note from 'assets/images/pages/community/note.webp';
import pencil from 'assets/images/pages/community/pencil.webp';

const { Title, Text } = Typography;

const InterviewReviewList = () => {
  const [loginRequestModal, setLoginRequestModal] = useState<TModalState>({ visible: false });
  const [pagination, setPagination] = usePagination(5);
  const [isFirstRendering, setIsFirstRendering] = useState(true); // 페이지네이션 됐을 때 스크롤 위로 올라오도록하기 위한?
  const [searchBar, setSearchBar] = useState(false);
  const history = useHistory();
  const [form] = Form.useForm();
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  const location = useLocation();
  const [completeModalVisible, setCompleteModalVisible] = useRecoilState(completeModalVisibleState);
  const [searchInputText, setSearchInputText] = useState<string | undefined>(pagination.q);
  const [selectedOrderingBtn, setSelectedOrderingBtn] = useState('등록순');

  const reloadPage = (page?: Partial<TPagination>) => {
    setPagination({
      ...pagination,
      ...page,
    });
    setIsFirstRendering(false);
  };

  const getPromise = getInterviewReviewList.bind(null, {
    params: {
      is_pass_review: pagination.is_pass_review,
      is_consulting_firm: pagination.is_consulting_firm,
      employment_types: pagination.employment_types,
      interview_years: pagination.interview_years,
      current: pagination.current,
      pageSize: pagination.pageSize,
      q: pagination.q,
      ordering: pagination.ordering ? pagination.ordering : 'created_at',
    },
  });

  const [{ data, loading }, setCallback] = useDataApi<TListResponse<TInterviewReview>>(getPromise, {
    contents: [],
    last: false,
  });

  const onClickRefresh = () => {
    reloadPage({
      is_pass_review: 'false',
      is_consulting_firm: undefined,
      employment_types: undefined,
      interview_years: undefined,
      current: 1,
      pageSize: pagination.pageSize,
      q: '',
      ordering: 'created_at',
    });
    form.setFieldsValue({
      employment_types: undefined,
      interview_years: undefined,
      is_consulting_firm: undefined,
    });
    setSearchInputText('');
    setSelectedOrderingBtn('등록순');
  };

  const hitCount = async () => {
    const res = await communityHitConut({ board: 'interview_review' });
  };

  useEffect(() => {
    hitCount();
  }, []);

  const urlQuery = getUrlQuery(location.search);

  useEffect(() => {
    // history.push(`/community/interview_review/?${makeQueryString(pagination)}`);
    setCallback(() => getPromise); //111111. pagination이 바뀔때마다 이걸해주는게 아니라 위에껄 해주고(url 바꿔주고)
  }, [pagination]);

  // useEffect(() => {
  //   setCallback(() => getPromise); //22222. url 쿼리 파라미터가 바뀔 때마다 데이터를 다시 불러와준다  ==>> 그러면 url 타고 왔을 때 데이터 그대로 반영되지 않을까???
  // }, [urlQuery]);

  // console.log('pagination', pagination);

  function upToScroll(loading: boolean, isFirstRendering: boolean) {
    if (!loading && !isFirstRendering) {
      scrollIntoView(document?.getElementById('card-list-header') as HTMLElement, {
        align: {
          top: 0.3,
        },
      });
    }
  }

  useEffect(() => {
    upToScroll(loading, isFirstRendering);
  }, [loading]);

  return (
    <Form form={form}>
      <CompleteModal
        visible={completeModalVisible}
        setVisible={setCompleteModalVisible}
        writePath={ERoute.InterviewReviewWrite.replace(':operation', 'create')}
        ListPath={ERoute.InterviewReviewBoard}
      >
        <CompleteModalChildren />
      </CompleteModal>
      <LoginRequiredModal
        modalState={loginRequestModal}
        setModalState={setLoginRequestModal}
        nextPath={ERoute.InterviewReviewWrite.replace(':operation', 'create')}
      />
      <InterviewReviewListWrapper>
        <StyledTopBanner>
          <Title className='pageTitle'>인터뷰 후기</Title>
          <Text className='pageSubtitle'>다양한 기업의 최근 기출질문을 확인하세요</Text>
        </StyledTopBanner>

        <section>
          <StyledGuideEnroll id='card-list-header'>
            <div className='guideHeader'>
              <img src={note} alt='ticket' />
              <p>{`매주 다섯분께 추첨을 통해 케이스 인터뷰 기초를 다질 수 있는 케이스 문제를 드립니다`}</p>
            </div>
            <Button
              className='secondary'
              onClick={() => {
                currentUser
                  ? history.push(ERoute.InterviewReviewWrite.replace(':operation', 'create'))
                  : setLoginRequestModal({ visible: true });
              }}
            >
              <div>인터뷰 후기 등록하기</div>
            </Button>
          </StyledGuideEnroll>
          <StyledReviews>
            {/* <ShareLinkMenu
              title={'제목'}
              description={'설명들어갈자리'}
              imageUrl={
                'http://k.kakaocdn.net/dn/Q2iNx/btqgeRgV54P/VLdBs9cvyn8BJXB3o7N8UK/kakaolink40_original.png'
              }
              pageUrl={'http://localhost:3000/community/interview_review'}
            /> */}

            <h1 className='title'>인터뷰 후기</h1>

            <div className='filters'>
              <div className='search'>
                <StyledSearchInput isActive='desktop'>
                  <Form.Item name='search_input' noStyle>
                    <ResettableSearchInput
                      pagination={pagination}
                      reloadPage={reloadPage}
                      placeHolder='기업을 검색하세요'
                      searchInputText={searchInputText}
                      setSearchInputText={setSearchInputText}
                    />
                  </Form.Item>
                </StyledSearchInput>
                <Form.Item name='search_input' noStyle>
                  <StyledSearchInput isActive='mobile'>
                    <SearchOutlined onClick={() => setSearchBar(true)} />
                    <ResettableSearchInput
                      pagination={pagination}
                      reloadPage={reloadPage}
                      placeHolder='기업을 검색하세요'
                      searchInputText={searchInputText}
                      setSearchInputText={setSearchInputText}
                      suffix={<CloseOutlined onClick={() => setSearchBar(false)} />}
                      style={{
                        display: searchBar ? 'flex' : 'none',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        minWidth: '100%',
                        height: '40px',
                        zIndex: 1,
                      }}
                    />
                  </StyledSearchInput>
                </Form.Item>

                <StyledSwitchContainer>
                  <Form.Item name='is_pass_review' noStyle>
                    <Switch
                      checked={pagination.is_pass_review === 'true'}
                      onChange={(e) => {
                        reloadPage({
                          current: 1,
                          is_pass_review: String(e),
                        });
                      }}
                      checkedChildren='ON'
                      unCheckedChildren='OFF'
                    />
                  </Form.Item>
                  <span className='switch-label'>합격후기만보기</span>
                </StyledSwitchContainer>
              </div>
              <div className='selectors'>
                <Form.Item name='is_consulting_firm' noStyle>
                  <Select
                    className='is-consulting-selector'
                    placeholder='회사유형'
                    onChange={(e) => {
                      reloadPage({
                        current: 1,
                        is_consulting_firm: String(e),
                      });
                    }}
                  >
                    <Select.Option value={'true'}>컨설팅펌</Select.Option>
                    <Select.Option value={'false'}>컨설팀펌 외</Select.Option>
                  </Select>
                </Form.Item>
                <Form.Item name='employment_types' noStyle>
                  <Select
                    className='employment-type-selector'
                    placeholder='고용형태'
                    onChange={(value) => {
                      reloadPage({
                        current: 1,
                        employment_types: String(value),
                      });
                    }}
                  >
                    <Select.Option value={EEmploymentType.Newcomer}>
                      {CEmploymentType[EEmploymentType.Newcomer]}
                    </Select.Option>
                    <Select.Option value={EEmploymentType.ExperiencedWorker}>
                      {CEmploymentType[EEmploymentType.ExperiencedWorker]}
                    </Select.Option>
                    <Select.Option value={EEmploymentType.TransitionalTypeIntern}>
                      {CEmploymentType[EEmploymentType.TransitionalTypeIntern]}
                    </Select.Option>
                    <Select.Option value={EEmploymentType.GeneralTypeIntern}>
                      {CEmploymentType[EEmploymentType.GeneralTypeIntern]}
                    </Select.Option>
                  </Select>
                </Form.Item>
                {/* <Form.Item name='interview_years' noStyle>
                  <Select
                    className='years-selector'
                    placeholder='연도'
                    onChange={(value) => {
                      reloadPage({
                        current: 1,
                        interview_years: Number(value),
                      });
                    }}
                  >
                    {makeLastNYearsList(4).map((year) => (
                      <Select.Option key={year} value={year}>
                        {year}년
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item> */}
                <ResettableOrderingButton
                  pagination={pagination}
                  reloadPage={reloadPage}
                  defaultKey='created_at'
                  orderingList={{
                    created_at: '등록순',
                    '-interview_info__interview_date': '면접일자순',
                  }}
                  selected={selectedOrderingBtn}
                  setSelected={setSelectedOrderingBtn}
                />

                <img className='refreshIcon' src={refresh} alt='refresh' onClick={onClickRefresh} />
              </div>
            </div>
            <List
              pagination={{
                ...pagination,
                total: get(data, 'total', 0),
                position: 'bottom',
                showSizeChanger: false,
                onChange: (page) => {
                  reloadPage({
                    current: page,
                    pageSize: pagination.pageSize,
                  });
                },
              }}
              className='card'
              loading={loading}
              style={{ paddingBottom: '20px', marginTop: '30px' }}
              split={false}
              grid={{ column: 1 }}
              dataSource={get(data, 'contents')}
              renderItem={(item: TInterviewReview) => (
                <List.Item>
                  <InterviewDetail
                    board='interview_review'
                    header={{
                      title: item.interview_information.company_name,
                      employment_type: item.interview_information.employment_type,
                      interview_date: item.interview_information.interview_date,
                    }}
                    data={{
                      interview_progress: item.interview_progress,
                      interview_atmosphere: item.interview_atmosphere,
                      interview_level: item.interview_level,
                      interview_pass: item.interview_information.interview_result,
                      fit_importance: item.fit_importance,
                      case_importance: item.case_importance,
                      questions: item.question.map((q) => q.question),
                    }}
                  />
                </List.Item>
              )}
            ></List>
          </StyledReviews>
        </section>
      </InterviewReviewListWrapper>
    </Form>
  );
};

export default InterviewReviewList;

type TResponsive = {
  isActive?: string;
};

const maxWidth = CWindowWidth - 450;

const InterviewReviewListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  word-break: keep-all;

  section {
    padding: 0 50px;
    @media screen and ${device.lg} {
      padding: 0 20px;
    }
  }
`;
export const StyledTopBanner = styled.div`
  width: 100%;
  height: 400px;
  padding: 0 10px;
  background-image: url(${pencil});
  background-size: cover;

  @media screen and ${device.md} {
    height: 205px;
  }

  .pageTitle {
    margin: 150px auto 0 auto;
    font-size: 56px;
    font-weight: 700;

    @media screen and ${device.md} {
      margin-top: 60px;
      font-size: 30px;
    }
  }

  .pageSubtitle {
    margin: 16px auto 0 auto;
    padding-left: 5px;
    font-size: 14px;

    @media screen and ${device.md} {
      font-size: 10px;
    }
  }

  .ant-typography {
    display: block;
    max-width: ${maxWidth}px;
    color: #ffffff;
  }
`;

const StyledReviews = styled.ul`
  max-width: 996px;
  width: 100%;
  margin-top: 20px;
  padding: 0;

  .title {
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #e4e4e4;
    font-size: 24px;
    font-weight: 900;
    color: ${PrimaryColor};
  }

  .filters {
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media screen and ${device.lg} {
      position: relative;
      flex-direction: column;
    }

    .search {
      width: 59%; //
      display: flex;
      justify-content: space-between;
      align-items: center;
      @media screen and ${device.lg} {
        width: 96%;
      }
    }

    .selectors {
      width: 39%; //
      display: flex;
      justify-content: end;
      align-items: center;
      @media screen and ${device.lg} {
        width: 93%;
        margin-top:6px;
        justify-content: space-between;
      }
    }

    .refreshIcon {
      margin-left: 5px;
      padding: 7px;
      border-radius: 8px;
      background-color: #f9f9f9;
      cursor: pointer;
    }
  

    & .is-consulting-selector.ant-select,
    .employment-type-selector.ant-select {
      width: 30%;
      margin-right:7px;
      /* @media screen and ${device.lg} {
        width: 22%;
      } */
    }
    & .years-selector.ant-select {
      /* width: 42%; */
      /* @media screen and ${device.lg} {
        width: 18%;
      } */
    }
    & .ant-dropdown-trigger {
      margin-left: 0px !important;
      /* margin-right: 7px; */
    }
    & .ant-select-selection-placeholder {
      color: ${PrimaryColor};
    }
  }
`;

const StyledSwitchContainer = styled.div`
  display: inline-flex;
  margin-right: 10px;
  color: ${PrimaryColor};

  & .switch-label {
    margin-left: 5px;
  }
`;

const StyledSearchInput = styled.div<TResponsive>`
  display: ${({ isActive }) => (isActive === 'desktop' ? 'block' : 'none')};
  width: 60%;
  @media screen and ${device.xs} {
    display: ${({ isActive }) => (isActive === 'mobile' ? 'block' : 'none')};
    width: 20%;
    .anticon.anticon-search {
      padding: 12px;
      border-radius: 7px;
      font-size: 16px;
      background-color: #f9f9f9;
    }
  }
`;

export const CompleteModalChildren = () => {
  return (
    <div className='normal-modal-container'>
      <div className='modal-desciption'>
        <p>소중한 인터뷰 경험 공유해주셔서 감사합니다.</p>
        <p>경품 추첨일은 매주 금요일이며, 당첨자는 계정 이메일을 통해 안내드립니다.</p>
        <br />
        <p>다른 기업의 인터뷰 후기 추가 작성 시 경품 당첨 확률이 올라갑니다.</p>
        <p style={{ color: Colors.grey2, fontSize: '0.9rem' }}>
          *Career Step 내부 검수 후 내용이 적절하지 않을 경우 경품 대상 제외 및 원문 삭제 될 수 있습니다.
        </p>
      </div>
      <div className='modal-desciption-small'>
        <p>소중한 인터뷰 경험 공유해주셔서 감사합니다.</p>
        <p>경품 추첨일은 매주 금요일이며, </p>
        <p>당첨자는 계정 이메일을 통해 안내드립니다.</p>
        <br />
        <p>다른 기업의 인터뷰 후기 추가 작성 시 </p>
        <p>경품 당첨 확률이 올라갑니다.</p>

        <div style={{ color: Colors.grey2, fontSize: '0.8rem' }}>
          <p>*Career Step 내부 검수 후 내용이 적절하지 않을 경우</p>
          <p>경품 대상 제외 및 원문 삭제 될 수 있습니다.</p>
        </div>
      </div>
    </div>
  );
};
